module.exports = __webpack_public_path__ + "static/media/chalkboard-teacher.bd8caaeb.svg";